import { createRouter, createWebHistory } from 'vue-router';
import Cookies from 'js-cookie'; // Instala con `npm install js-cookie`

import LayoutDefault from '@/views/layouts/LayoutDefault.vue';
import LayoutAdmin from '@/views/layouts/LayoutAdmin.vue';

/*
import ViewHome from '@/views/client/ViewHome.vue';
import ViewReservas from '@/views/client/ViewReservas.vue';
import ViewFotos from '@/views/client/ViewFotos.vue';
import ViewVideos from '@/views/client/ViewVideos.vue';
import ViewTraslado from '@/views/client/ViewTraslado.vue';
import ViewComoLlegar from '@/views/client/ViewComoLlegar.vue';
import ViewNosotros from '@/views/client/ViewNosotros.vue';
import ViewExperiencias from '@/views/client/ViewExperiencias.vue';
import ViewTarifas from '@/views/client/ViewTarifas.vue';
*/
//import ViewMercadoPago from '@/views/client/ViewMercadoPago.vue';

import ViewAdminFechas from '@/views/admin/ViewAdminFechas.vue';
import ViewAdminPrecios from '@/views/admin/ViewAdminPrecios.vue';
import ViewAdminLogin from '@/views/admin/ViewAdminLogin.vue';
import ViewAdminReservas from '@/views/admin/ViewAdminReservas.vue';
import ViewAdminGaleria from '@/views/admin/ViewAdminGaleria.vue';

import ViewNotFound from '@/views/ViewNotFound.vue';
import ViewMercadoSuccess from '@/views/mercado/ViewMercadoSuccess.vue';
import ViewMercadoFailure from '@/views/mercado/ViewMercadoFailure.vue';
import ViewMercadoPending from '@/views/mercado/ViewMercadoPending.vue';
import ViewLanding from '@/views/client/ViewLanding.vue';


const routes = [
  // LOGIN
  {
    path: '/login',
    name: 'ViewAdminLogin',
    component: ViewAdminLogin
  },
  // CLIENT
  
  {
    path: '/',
    component: LayoutDefault,
    children: [
      { path: '/', name: 'ViewLanding', component: ViewLanding },
      /*
      { path: '', name: 'ViewHome', component: ViewHome },
      { path: 'reservas', name: 'ViewReservas', component: ViewReservas },
      { path: 'fotos', name: 'ViewFotos', component: ViewFotos },
      { path: 'videos', name: 'ViewVideos', component: ViewVideos },
      { path: 'traslado', name: 'ViewTraslado', component: ViewTraslado },
      { path: 'como-llegar', name: 'ViewComoLlegar', component: ViewComoLlegar },
      { path: 'nosotros', name: 'ViewNosotros', component: ViewNosotros },
      { path: 'experiencias', name: 'ViewExperiencias', component: ViewExperiencias },
      { path: 'tarifas', name: 'ViewTarifas', component: ViewTarifas },
      */
      //{ path: 'mercado-pago', name: 'ViewMercadoPago', component: ViewMercadoPago },
    ]
  },
  // ADMIN
  {
    path: '/admin',
    component: LayoutAdmin,
    meta: { requiresAuth: true }, // Definimos que requiere autenticación
    children: [
      { path: 'reservas', name: 'ViewAdminReservas', component: ViewAdminReservas, meta: { requiresAuth: true } },
      { path: 'fechas', name: 'ViewAdminFechas', component: ViewAdminFechas, meta: { requiresAuth: true } },
      { path: 'precios', name: 'ViewAdminPrecios', component: ViewAdminPrecios, meta: { requiresAuth: true } },
      { path: 'galeria', name: 'ViewAdminGaleria', component: ViewAdminGaleria, meta: { requiresAuth: true } },
    ]
  },
  {
    path: '/mercado',
    children: [
      { path: 'success', name: 'ViewMercadoSuccess', component: ViewMercadoSuccess},
      { path: 'failure', name: 'ViewMercadoFailure', component: ViewMercadoFailure},
      { path: 'pending', name: 'ViewMercadoPending', component: ViewMercadoPending},
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: ViewNotFound }
];

const router = createRouter({
  history: createWebHistory('/refugio/'),  // Agrega el prefijo de la ruta base aquí
  routes
});


// PROTECCIÓN DE RUTAS ADMIN
router.beforeEach((to, from, next) => {
  const token = Cookies.get('token'); // Lee la cookie 'token'

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login'); // Si no hay token, redirige al login
    } else {
      next(); // Si hay token, sigue la navegación
    }
  } else {
    next(); // Para rutas públicas, sigue la navegación
  }
});

export default router;
